<template>
  <div class="tm-form-line">
    <h6
      class="tm-form-line__label ellipsis"
      :class="{
        'tm-form-line__label--required': required,
      }"
    >
      {{ label }}
    </h6>

    <div class="mt-1">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.tm-form-line {
  &__label {
    line-height: 20px;
    color: $emphasize;
    overflow: hidden;
    text-overflow: ellipsis;

    &--required:after {
      content: ' *';
      color: $red600;
      margin-left: -2px;
      font-weight: $semi-bold-font;
    }
  }
}
</style>
